module.exports = __webpack_public_path__ + "static/media/maxim3.ef551522.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/maxim3.png
// module id = 684
// module chunks = 0